module.exports = __webpack_public_path__ + "static/media/shift.32a67a40.svg";